import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../common/Button";
import { FormLayout } from "../common/FormLayout";
import { Icon } from "../common/Icon";

export const SelectFarmTypePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { formData } = location.state || {};
  const [farmType, setFarmType] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);

    if (!farmType) {
      setError("Veuillez sélectionner un type d'élevage");
      return;
    }

    navigate("/register/confirm", {
      state: {
        formData,
        farmType,
      },
    });
  };

  return (
    <FormLayout title="Inscription - Type d'élevage">
      <form onSubmit={handleSubmit} className="space-y-6">
        {error && (
          <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        <div className="flex justify-center gap-8 mb-8">
          <button
            type="button"
            onClick={() => setFarmType("volaille")}
            className={`flex flex-col items-center group ${
              farmType === "volaille"
                ? "opacity-100"
                : "opacity-70 hover:opacity-100"
            }`}
          >
            <div
              className={`w-24 h-24 ${
                farmType === "volaille" ? "bg-tertiary" : "bg-tertiary/80"
              } rounded-full flex items-center justify-center mb-4 group-hover:bg-tertiary transition-colors`}
            >
              <Icon icon="chicken" size={4} className="text-secondary-text" />
            </div>
            <span className="text-tertiary font-oxaniumMedium">
              Eleveur volaille
            </span>
          </button>

          <button
            type="button"
            onClick={() => setFarmType("porc")}
            className={`flex flex-col items-center group ${
              farmType === "porc"
                ? "opacity-100"
                : "opacity-70 hover:opacity-100"
            }`}
          >
            <div
              className={`w-24 h-24 ${
                farmType === "porc" ? "bg-tertiary" : "bg-tertiary/80"
              } rounded-full flex items-center justify-center mb-4 group-hover:bg-tertiary transition-colors`}
            >
              <Icon icon="pig" size={4} className="text-secondary-text" />
            </div>
            <span className="text-tertiary font-oxaniumMedium">
              Eleveur porc
            </span>
          </button>
        </div>

        <div className="flex gap-4">
          <Button
            type="button"
            variant="secondary"
            size="full"
            onClick={() => navigate(-1)}
          >
            Retour
          </Button>
          <Button type="submit" size="full">
            SUIVANT
          </Button>
        </div>
      </form>
    </FormLayout>
  );
};
